 


  import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useUpdateUserProfileMutation, useUserProfleByIdQuery } from "../apis/UsersApi";
import { getUserData } from "../auth";

const UserProfileView = () => {


  // Extract user data from localStorage
  const userData = getUserData();
  const userId = userData?.uid || "";
  console.log('userProfile userId', userId);

  const [updateUserProfile, { isLoading, isError, isSuccess }] =
    useUpdateUserProfileMutation();

  // State for user data
 const { data, error, isLoading:isLoadingProfile } = useUserProfleByIdQuery(userId, {
  skip: !userId, // Skip the query if userId is not available
});
 // Initialize the useForm hook with defaultValues only when data is available
 const { register, handleSubmit, formState: { errors }, setValue } = useForm({
  defaultValues: data || {} // Initialize with data if available
});  // Initialize the useForm hook
      
  const onSubmit = async (data) => {
    try {
      console.error('Fail data:', data);
      console.error('Failed userId :', userId);

      await updateUserProfile({ id:userId, ProfileRequestUpdate: data }).unwrap();
      alert('Profile updated successfully!');
    } catch (err) {
      console.error('Failed to update profile:', err);
    }
  };

  console.log('userProfile', data);
  useEffect(() => {
    if (data) {
      // Set the form values when data is loaded
      setValue("username", data.username || '');
      setValue("nomPrenom", data.nomPrenom || '');
      setValue("email", data.email || '');
      setValue("phoneNumber", data.phoneNumber || '');
      setValue("firstName", data.firstName || '');
      setValue("lastName", data.lastName || '');
     }
  }, [data, setValue]); // Re-run when data changes

  if (isLoadingProfile) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading user data</div>;
  }

  return (
    <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h6 className="mb-32">Edit User Profile</h6>
        <div className="row gy-4">
          <div className="col-sm-6">
            <label
              htmlFor="username"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Username{" "}
              <span className="text-danger text-xl line-height-1">*</span>
            </label>
            <input
              type="text"
              className="common-input px-16"
              id="username"
              placeholder="Username"
              {...register("username", {
                required: "Username is required",
                minLength: {
                  value: 3,
                  message: "Username must be between 3 and 20 characters",
                },
                maxLength: {
                  value: 20,
                  message: "Username must be between 3 and 20 characters",
                },
              })}
            />
            {errors.username && (
              <p className="text-danger text-sm">{errors.username.message}</p>
            )}
          </div>

          <div className="col-sm-6">
            <label
              htmlFor="nomPrenom"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Full Name{" "}
              <span className="text-danger text-xl line-height-1">*</span>
            </label>
            <input
              type="text"
              className="common-input px-16"
              id="nomPrenom"
              placeholder="Full name"
              {...register("nomPrenom", { required: "Full name is required" })}
            />
            {errors.nomPrenom && (
              <p className="text-danger text-sm">{errors.nomPrenom.message}</p>
            )}
          </div>

          <div className="col-sm-6">
            <label
              htmlFor="email"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Email Address{" "}
              <span className="text-danger text-xl line-height-1">*</span>
            </label>
            <input
              type="email"
              className="common-input px-16"
              id="email"
              placeholder="Email address"
              {...register("email", {
                required: "Email address is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Enter a valid email address",
                },
              })}
            />
            {errors.email && (
              <p className="text-danger text-sm">{errors.email.message}</p>
            )}
          </div>

          <div className="col-sm-6">
            <label
              htmlFor="phoneNumber"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Phone Number
            </label>
                              <input
                                    type="tel"
                                    className="common-input"
                                    id="telephone"
                                    placeholder="Enter Telephone Number"
                                    {...register("phoneNumber", { required: true })}
                                />
            {errors.phone && (
              <p className="text-danger text-sm">{errors.phone.message}</p>
            )}
          </div>

          <div className="col-sm-6">
            <label
              htmlFor="firstName"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              First Name
            </label>
            <input
              type="text"
              className="common-input px-16"
              id="firstName"
              placeholder="First name"
              {...register("firstName", {
                maxLength: {
                  value: 50,
                  message: "First name must be less than 50 characters",
                },
              })}
            />
            {errors.firstName && (
              <p className="text-danger text-sm">{errors.firstName.message}</p>
            )}
          </div>

          <div className="col-sm-6">
            <label
              htmlFor="lastName"
              className="text-sm font-heading-two text-gray-900 fw-semibold mb-4"
            >
              Last Name
            </label>
            <input
              type="text"
              className="common-input px-16"
              id="lastName"
              placeholder="Last name"
              {...register("lastName", {
                maxLength: {
                  value: 50,
                  message: "Last name must be less than 50 characters",
                },
              })}
            />
            {errors.lastName && (
              <p className="text-danger text-sm">{errors.lastName.message}</p>
            )}
          </div>

          <div className="col-sm-12 mt-32">
            <button type="submit" className="btn btn-main py-18 px-32 rounded-8 " disabled={isLoading}>
            {isLoading ? 'Updating...' : 'Update Profile'}
            </button> 

          </div>
        </div>
      </form>
      {isSuccess && <p>Profile updated successfully!</p>}
      {isError && <p>Failed to update profile. Please try again.</p>}
    
    </div>
  );
};

export default UserProfileView;
